import React, { useState } from "react";
import { Link } from "react-router-dom";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { label: "About", path: "/about" },
    { label: "Resume", path: "/resume" },
    { label: "Projects", path: "/projects" },
    { label: "Contact", path: "/contact" },
  ];

  return (
    <header className="fixed top-0 z-50 w-full border-b border-slate-800 bg-slate-950/90 backdrop-blur">
      <nav className="flex w-full items-center justify-between px-6 py-5 md:px-10 lg:px-14">
        <Link
          to="/"
          className="group flex items-center gap-3"
          onClick={() => setIsOpen(false)}
        >
          <div className="relative flex h-11 w-11 items-center justify-center rounded-lg border border-cyan-400/70 bg-slate-900 text-xl font-black text-cyan-300 shadow-lg shadow-cyan-500/10 transition group-hover:bg-cyan-400/10 group-hover:shadow-cyan-400/20">
            <span className="absolute inset-0 rounded-lg bg-cyan-400/10 blur-md opacity-0 transition group-hover:opacity-100" />
            <span className="relative">G</span>
          </div>

          <div className="hidden sm:block leading-tight">
            <p className="text-sm font-semibold text-slate-200">
              Gabriel Espinosa
            </p>
            <p className="text-xs text-slate-500">
              Software Engineer
            </p>
          </div>
        </Link>

        <button
          className="text-2xl text-cyan-300 md:hidden"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle navigation"
        >
          {isOpen ? "✕" : "☰"}
        </button>

        <ul className="hidden items-center space-x-8 md:flex">
          {navLinks.map((link, index) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className="text-sm font-medium text-slate-400 transition hover:text-cyan-300"
              >
                <span className="mr-1 text-cyan-400">
                  0{index + 1}.
                </span>
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {isOpen && (
          <ul className="absolute left-0 top-20 flex w-full flex-col items-center space-y-6 border-b border-slate-800 bg-slate-950 px-6 py-8 shadow-xl md:hidden">
            {navLinks.map((link, index) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className="text-base font-medium text-slate-300 transition hover:text-cyan-300"
                  onClick={() => setIsOpen(false)}
                >
                  <span className="mr-2 text-cyan-400">
                    0{index + 1}.
                  </span>
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </nav>
    </header>
  );
}

export default Navbar;